import './Project/globals';

import 'jquery';
import 'picturefill';
import 'object-fit-videos';
import 'vanilla-lazyload';
import 'lazyembed2';
import 'webkit-line-clamp';
import './Project/placeholderShownPolyFill';

/**
 * Bootstrap
 */
import 'bootstrap/js/src/util';
//import 'bootstrap/js/src/alert';
//import 'bootstrap/js/src/button';
import 'bootstrap/js/src/carousel';
// import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/dropdown';
//import 'bootstrap/js/src/modal';
//import 'bootstrap/js/src/scrollspy';
import 'bootstrap/js/src/tab';
//import 'bootstrap/js/src/tooltip';
//import 'bootstrap/js/src/popover';

/**
 * Multiselect
 */
import '@erkenes/multiselect'

/**
 * Slick
 */
import 'slick-carousel';

/**
 * Light Galery
 */
import 'lightgallery';
//import 'lg-autoplay';
//import 'lg-fullscreen';
//import 'lg-hash';
//import 'lg-pager';
//import 'lg-share';
//import 'lg-thumbnail';
//import 'lg-video';
//import 'lg-zoom';

import 'simplebar';

import 'justifiedGallery';

/**
 * Project
 */
import './Project/Viewport';
import './Project/sizeChange';
import './Project/PageLoadedQueue';
import './Project/objectFitVideos';
import './Project/counter';
import './Project/circleCounter';
import './Project/downloadFilters';
import './Project/lightGallery';
import './Project/lazyload';
import './Project/lazyEmbed';
import './Project/slick';
import './Project/Clamp';
import './Project/Select';
import './Project/ShopSearch';
import './Project/anchorlink';
import './Project/makeElementActive';
import './Project/annotations';
import './Project/otherSelect';
import './Project/DropdownHelper';
import './Project/jumpButton';
import './Project/collapseLoad';
import './Project/loadMore';
import './Project/moveModal';
import './Project/tooltip';
import './Project/MercuryAI';
import './Project/MainMenu';
import './Project/StickyHeader';
import '../../../../Avency.Nwd.Locations/Resources/Private/JavaScript/index.js';
import '../../../../Avency.Plandent.Gallery/Resources/Private/Fusion/Component/Molecule/GallerySlider/GallerySlider'
import './Project/SplideSlider';
import './Project/FormDatePicker';
